import React, { useEffect } from "react";
import { useSettings } from "@/contexts/SettingsContext";

/**
 * Injects Schema.org Restaurant JSON-LD into the document head.
 * Drives Google rich results: opening hours, address, price range, geo, etc.
 */
export default function SeoSchema() {
  const { settings: s } = useSettings();

  useEffect(() => {
    if (!s) return;
    const data = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "@id": "https://restaurantle17.com/#restaurant",
      name: s.restaurant_name || "Le 17",
      description: s.tagline?.fr || "Restaurant d'exception à Mulhouse",
      url: "https://restaurantle17.com",
      telephone: s.phone,
      email: s.email,
      servesCuisine: s.cuisine || "French",
      priceRange: s.price_range || "€€€",
      acceptsReservations: "True",
      address: {
        "@type": "PostalAddress",
        streetAddress: s.street || "17 rue Paille",
        postalCode: s.postal_code || "68100",
        addressLocality: s.city || "Mulhouse",
        addressRegion: "Grand Est",
        addressCountry: s.country || "FR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: s.latitude || 47.7508,
        longitude: s.longitude || 7.3359,
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Friday", "Saturday", "Sunday"],
          opens: "11:30",
          closes: "14:30",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Thursday"],
          opens: "11:30",
          closes: "14:30",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Friday", "Saturday", "Sunday"],
          opens: "18:00",
          closes: "23:00",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Thursday"],
          opens: "18:30",
          closes: "23:00",
        },
      ],
      sameAs: [s.instagram_url, s.facebook_url].filter(Boolean),
      hasMenu: "https://restaurantle17.com/menu",
      paymentAccepted: (s.payment_methods || []).map(m => ({
        cash: "Cash",
        contactless: "Contactless",
        mastercard: "Mastercard",
        visa: "Visa",
        apple_pay: "Apple Pay",
        maestro: "Maestro",
      }[m] || m)).join(", "),
      amenityFeature: Object.entries(s.amenities || {})
        .filter(([, v]) => v)
        .map(([k]) => ({
          "@type": "LocationFeatureSpecification",
          name: ({
            wheelchair_accessible: "Wheelchair accessible",
            air_conditioning: "Air conditioning",
            outdoor_seating: "Outdoor seating",
            heated_terrace: "Heated terrace",
            wifi: "Free Wi-Fi",
          })[k] || k,
          value: true,
        })),
      potentialAction: {
        "@type": "ReserveAction",
        target: "https://restaurantle17.com/reservation",
        result: {
          "@type": "FoodEstablishmentReservation",
          name: "Reserve a table at Le 17",
        },
      },
    };
    const id = "le17-schema-restaurant";
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);
    return () => { /* keep across navigations */ };
  }, [s]);

  return null;
}
